// extracted by mini-css-extract-plugin
export default {"navigation-dot-wrapper":"NavigationDot_navigation-dot-wrapper__Hb-mf","navigation-dot":"NavigationDot_navigation-dot__1rMdu"};